/**
 * ProductsPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  ProductItem,
  FilterOption,
  Button,
  Pagination,
  Text,
  DropDownMenu,
  Collapse02,
  Image,
  Slider,
  ModalLayout,
} from 'components';
import { encrypt } from 'utils/Crypto';
import { Badge, Empty, Spin } from 'antd';
import Cart from 'assets/icon/cart_icon.svg';
import Heart from 'assets/icon/heart_icon.svg';
import { ProductCartModal, ProductSubscribe } from './components';
import { HeartFilled } from '@ant-design/icons';
import CategoryList from '../Main/components/CategoryList';
import Filter from 'assets/icon/filter_icon.svg';
import { useSearchParams } from 'react-router-dom';
import Present from 'assets/present_image.jpg';
import Rental1 from 'assets/rental_image1.jpg';
import Rental2 from 'assets/rental_image2.jpg';
import coffeeCategoryImg from 'assets/coffee_pc.jpg';
import coffeeCategoryImgM from 'assets/coffee_m.jpg';
import machineCategoryImgP from 'assets/mg_pc.jpg';
import machineCategoryImgM from 'assets/mg_m.jpg';
import giftCategoryImgP from 'assets/gift_pc.jpg';
import giftCategoryImgM from 'assets/gift_m.jpg';
import subscriptionImgP from 'assets/sub_pc.jpg';
import subscriptionImgM from 'assets/sub_m.jpg';

const PAGE_NUM = [
  { label: '12개씩', value: 12 },
  { label: '24개씩', value: 24 },
  { label: '36개씩', value: 36 },
  { label: '48개씩', value: 48 },
];

const ProductsPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    navigate,
    location,
    user = null,
    products = [],
    categories,
    categoryList = [],
    selectedCategory,
    cartList,
    filterItems,
    type,
    classification,
    brand,
    onSubmit,
    modalData,
    setModalData,
    sortItems,
    screenSize,
  } = props;

  /* ===== STATE ===== */
  // 정렬키값
  const [tabKey, setTabKey] = React.useState(sortItems[0].key);
  // 페이지에 보여질 수
  const [pageSize, setPageSize] = React.useState(PAGE_NUM[0].value);
  // 선택된 필터 값
  const [selectedFilter, setSelectedFilter] = React.useState([]);
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);
  // 상품 목록
  const [productItems, setProductItems] = React.useState([]);
  // 페이징
  const [currentPage, setCurrentPage] = React.useState(1);
  // 모바일 필터 모달
  const [isOpen, setIsOpen] = React.useState(false);
  //
  const [selectedTagList, setSelectedTagList] = React.useState([]);

  const [searchParams] = useSearchParams();
  const isSubscription = searchParams.get('type') === 'subscription';
  const isPresent = searchParams.get('type') === 'present';
  const isRental = searchParams.get('type') === 'rental';

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 72 : screenSize >= 500 ? 40 : 28,
      fontFamily: `"Dela Gothic One", sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      textTransform: 'capitalize',
      marginBottom: screenSize >= 768 ? 100 : 60,
    },

    button: {
      width: '46%',
      minWidth: 78,
      height: 48,
      fontSize: 16,
      fontWeight: 700,
      borderRadius: 0,
    },

    categoryWrap: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      marginBottom: 12,
    },
    categoryTitle: {
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '28px',
      cursor: 'pointer',
    },
    categoryItem: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '28px',
      color: '#666666',
      border: 'none',
      flex: 1,
      cursor: 'pointer',
    },

    paginationButton: {
      color: 'var(--black-color)',
      width: 28,
      height: 28,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    imageWrap: {
      padding: 0,
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      rowGap: 20,
      //height: screenSize >= 768 ? '41.66vw' : '102vw',
      //backgroundColor: '#efefef',
      overflow: 'hidden',
    },
    subscribeImage: {
      borderRadius: 15,
      backgroundColor: '#fff',
      border: '1px solid #ddd',
      height: screenSize >= 768 ? '34.37vw' : '83vw',
    },
  };

  /* ===== FUNCTION ===== */
  /**
   * 카테고리 라우팅
   * --
   * @param {number} category
   */
  const handleCategoryRoute = (category) => {
    // 기존 쿼리 파라미터 가져오기
    const currentParams = new URLSearchParams(location.search);

    // 카테고리 쿼리 추가
    currentParams.set('category', encodeURIComponent(encrypt(category)));

    // 쿼리와 함께 새로운 URL로 이동
    navigate(`${location.pathname}?${currentParams.toString()}`, {
      replace: true,
    });
  };

  /**
   * 카테고리 Tree 렌더
   * --
   * @param {object} items
   * @returns
   */
  const renderChild = (items) => {
    const { children, title, key } = items;

    const splitKey = key.split('-');
    const depth = splitKey.length;
    const paddingNum = depth - 1 > 3 ? 3 : depth - 1;

    return children.length ? (
      <Collapse02
        key={key}
        title={title}
        titleStyle={{
          ...styles.categoryItem,
          paddingLeft: 24 * paddingNum,
          ...(selectedCategory?.product_category_id.toString() ===
            splitKey[depth - 1] && {
            color: '#D33444',
            fontWeight: 700,
          }),
        }}
        children={children.map((child) => renderChild(child))}
        //defaultOpened={true}
        collapsible={'icon'}
        onClick={() => handleCategoryRoute(splitKey[depth - 1])}
        iconColor={'#666666'}
      />
    ) : (
      <p
        key={key}
        style={{
          ...styles.categoryItem,
          paddingLeft: 24 * paddingNum,
          ...(selectedCategory?.product_category_id.toString() ===
            splitKey[depth - 1] && {
            color: '#D33444',
            fontWeight: 700,
          }),
        }}
        onClick={() => handleCategoryRoute(splitKey[depth - 1])}
      >
        {title}
      </p>
    );
  };

  /**
   * 장바구니/위시리스트 모달
   * --
   */
  const handleRenderModal = (t, d = null) => {
    if (!user) {
      const confirm = window.confirm(
        '로그인 후 이용가능합니다.\n로그인하시겠습니까?',
      );

      if (confirm) {
        navigate('signin', {
          state: {
            from: `${location.pathname}${
              location.search ? location.search : ''
            }`,
          },
        });
      } else {
        return;
      }
    }

    if (t === 'wishlist' && d.isWish) {
      const confirm = window.confirm('찜 목록에서 삭제하시겠습니까?');

      if (confirm) {
        return onSubmit('remove', d);
      } else {
        return;
      }
    }

    if (!d) return setModalData({ type: '', data: null });
    else setModalData({ type: t, data: d });
  };

  /**
   * 필터 핸들러
   * --
   */
  const handleSelectFilter = React.useCallback((key, value, type) => {
    setSelectedFilter((prev) => {
      const fid = prev.findIndex((select) => select.key === key);
      if (fid === -1) {
        return [...prev, { key, value, type }];
      }
      const existingFilter = prev[fid];
      // 상태가 동일하면 업데이트 생략
      if (existingFilter.value === value && existingFilter.type === type) {
        return prev;
      }
      // 기존 필터 업데이트
      const updatedFilter = [...prev];
      updatedFilter[fid] = { key, value, type };
      return updatedFilter;
    });
  }, []);

  /**
   * 필터 검색
   * --
   */
  const handleSearch = (types) => {
    const searchType = types.toLocaleUpperCase();

    let filterProduct = [];
    setIsLoading(true);

    switch (searchType) {
      case 'RESET':
        filterProduct = productList;
        setSelectedFilter([]);
        break;
      case 'SEARCH':
        const filterItems = selectedFilter.filter(
          (select) => select.value && select.value.length,
        );
        const filterList = productList.filter((product) =>
          filterItems.every(({ key, type, value }) => {
            switch (type) {
              case 'include':
                // value 배열에 product[key]가 포함되는지 확인
                return value.includes(product[key]);
              case 'range':
                // value 배열의 범위 중 하나라도 product[key]가 포함되면 true
                return value.some(
                  ([min, max]) => product[key] >= min && product[key] < max,
                );
              default:
                // 알 수 없는 type은 기본적으로 true
                return true;
            }
          }),
        );
        filterProduct = filterList;
        break;
      default:
        filterProduct = productList;
        break;
    }

    setTimeout(() => {
      filterProduct =
        type !== 'present'
          ? filterProduct?.filter((item) => item?.type !== 'AMOUNT')
          : filterProduct;
      setProductItems(filterProduct);
      setIsLoading(false);
    }, 500);
  };
  /**
   * 카테고리별 이미지 결정 함수
   * --
   */
  const chooseCategoryImg = (type) => {
    if (!type) return;
    switch (type) {
      case 'best':
        return screenSize >= 768 ? coffeeCategoryImg : coffeeCategoryImgM;
      case 'new':
        return screenSize >= 768 ? machineCategoryImgP : machineCategoryImgM;
      case 'present':
        return screenSize >= 768 ? giftCategoryImgP : giftCategoryImgM;
      case 'rental':
        return screenSize >= 768 ? subscriptionImgP : subscriptionImgM;
      default:
        return undefined;
    }
  };
  /* ===== HOOKS ===== */
  /**
   * 카테고리에 따른 상품 정제
   * --
   */
  const productList = React.useMemo(() => {
    if (!selectedCategory && !selectedTagList.length) return products;

    let filterList = [...products];
    if (selectedCategory) {
      const { product_category_id } = selectedCategory;

      // NOTE: 카테고리 필터링
      filterList = filterList?.filter((product) => {
        const { category } = product;

        const splitKey = category?.split('-');

        return splitKey?.some((sk) => product_category_id?.toString() === sk);
      });
    }

    // NOTE: 태그 필터링
    if (selectedTagList.length) {
      filterList = filterList?.filter((product) =>
        selectedTagList.every((tag) =>
          product.tags?.some((pTag) => pTag.id === tag.id),
        ),
      );
    }
    return filterList;
  }, [products, selectedCategory, selectedTagList]);

  /**
   * 상품 목록 초기화
   * --
   */
  React.useEffect(() => {
    // 정렬
    const tapSplit = tabKey.split('-');
    const filterPriduct =
      type !== 'present'
        ? productList?.filter((item) => item.type !== 'AMOUNT')
        : productList;
    const sortData = [...filterPriduct].sort((a, b) => {
      switch (tapSplit[0]) {
        case 'ASC':
          return a[tapSplit[1]] - b[tapSplit[1]];
        case 'DESC':
          return b[tapSplit[1]] - a[tapSplit[1]];
        default:
          return 0;
      }
    });

    setSelectedFilter([]);
    setProductItems(sortData);
  }, [productList, tabKey]);

  /**
   * 정렬값 초기화
   * --
   */
  React.useEffect(() => {
    if (isPresent) {
      setTabKey(sortItems[5].key);
      return;
    }
    setTabKey(sortItems[0].key);
  }, [sortItems, searchParams]);

  /*
   * 필터 모달 열릴 때 전체 스크롤 숨김
   * --
   */
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden'; // iOS 대응
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = ''; // 원래 상태 복구
    }

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = ''; // 원래 상태 복구
    };
  }, [isOpen]);

  React.useEffect(() => {
    const handleBackButton = () => {
      if (isOpen) {
        setIsOpen(false);
        return;
      }

      // 모든 모달이 닫힌 상태라면 히스토리를 원래 상태로 되돌림
      window.history.replaceState(null, '', window.location.href);
    };

    const handlePopState = () => {
      handleBackButton();
    };

    // 모달이 열릴 때 히스토리 추가
    if (isOpen) {
      window.history.pushState(null, '', window.location.href);
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isOpen]);
  const titleType = {
    delivery: selectedCategory?.product_category_sub_name ?? 'Category',
    subscription: 'Regular Delivery', //정기배송
    //
    best: 'Coffee', //베스트셀러
    new: 'Machine & Goods', //신상품
    present: 'Gift', //선물하기
    promotions: 'Promotions', //기획전
    rental: 'subscription',
    recipe: 'Recommend',
  };
  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={
            screenSize >= 1200
              ? '100px 0px'
              : screenSize >= 768
                ? '80px 0'
                : '60px 0'
          }
          className="products"
        >
          <Row gutter={16}>
            <Col x={0} md={1} xxl={2}></Col>
            <Col x={24} md={22} xxl={20}>
              <Title style={{ ...styles.title }} align={'center'}>
                {classification
                  ? classification === 'promotion'
                    ? 'Promotion'
                    : classification === 'brand'
                      ? 'Brand'
                      : titleType[type]
                  : titleType[type]}
              </Title>
              <img
                src={chooseCategoryImg(type)}
                style={{
                  maxWidth: '100%',
                }}
              />

              {classification === 'brand' && brand.length ? (
                <div
                  style={{
                    margin: screenSize >= 768 ? '120px 0 0' : '60px 0',
                    overflow: 'hidden',
                  }}
                >
                  <Slider
                    items={brand}
                    loop={true}
                    spaceBetween={90}
                    slidesPerView={'auto'}
                    style={{ overflow: 'visible' }}
                    modules={['Autoplay']}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    itemStyle={{ maxWidth: 495 }}
                    render={(_item) => (
                      <div
                        key={`shop_${_item.shop_information_name}_${_item.shop_information_id}`}
                        style={{ width: '100%', cursor: 'pointer' }}
                        onClick={() =>
                          navigate(
                            `/brand/${encodeURIComponent(
                              encrypt(_item.shop_information_id),
                            )}`,
                          )
                        }
                      >
                        <Image
                          src={_item.thumbnail}
                          width={'100%'}
                          height={270}
                          noImageText={_item.shop_information_name}
                        />
                      </div>
                    )}
                  />
                </div>
              ) : null}

              {/* ===== 정기배송일 때 ==== */}
              {isSubscription ? (
                <ProductSubscribe
                  screenSize={screenSize}
                  navigate={navigate}
                  products={products}
                  onChange={(arr) => setSelectedTagList(arr)}
                />
              ) : null}

              {/* ===== 렌탈일 때 ==== */}
              {isRental ? (
                <Row
                  gutter={16}
                  style={{
                    width: '100%',
                    margin: screenSize >= 768 ? '120px 0 120px' : '60px 0 60px',
                    overflow: 'hidden',
                  }}
                >
                  <Col
                    x={24}
                    style={{
                      ...styles.imageWrap,
                      //height: screenSize >= 768 ? '41.66vw' : '80vw',
                    }}
                  ></Col>
                </Row>
              ) : null}

              {/* ===== 선물하기일 때 ==== */}
              {isPresent ? (
                <Row
                  gutter={16}
                  style={{
                    width: '100%',
                    margin: screenSize >= 768 ? '0px 0 0' : '0px 0 0',
                    overflow: 'hidden',
                  }}
                >
                  <Col
                    x={24}
                    style={{
                      ...styles.imageWrap,
                      //height: screenSize >= 768 ? '41.66vw' : '80vw',
                    }}
                  ></Col>
                  {/* 이미지 가로 2개 정렬일 때 */}
                  {/* <Col
                    x={24}
                    md={12}
                    style={{
                      backgroundImage: `url("/jm-coffee-roasters-03_1903x954.jpg")`,
                      ...styles.imageWrap,
                    }}
                  >
                    image
                  </Col>
                  <Col
                    x={24}
                    md={12}
                    style={{
                      backgroundImage: `url("/jm-coffee-roasters-03_1903x954.jpg")`,
                      ...styles.imageWrap,
                    }}
                  >
                    image
                  </Col> */}

                  <CategoryList
                    screenSize={screenSize}
                    categories={categories}
                    isPresent={true}
                  />
                </Row>
              ) : null}

              <Row
                gutter={16}
                style={{ marginTop: screenSize >= 768 ? 60 : 0 }}
              >
                {/* 필터 */}
                <Col x={0} md={6} lg={5}>
                  {/* SECTION: 카테고리 영역 */}
                  {/* 선물하기일 때 카테고리 숨김 */}
                  {!isPresent && (
                    <div style={{ borderBottom: '2px solid #111111' }}>
                      <Collapse02
                        title={'카테고리'}
                        titleStyle={{
                          border: 'none',
                          fontSize: 16,
                          fontWeight: 700,
                          padding: 0,
                          height: 52,
                          borderBottom: '2px solid #111111',
                          marginBottom: 24,
                          alignItems: 'flex-start',
                        }}
                        children={categoryList?.map((category) => (
                          <div
                            key={`category-${category.key}`}
                            style={{ ...styles.categoryWrap }}
                          >
                            <h4
                              style={{
                                ...styles.categoryTitle,
                                ...(selectedCategory?.product_category_id.toString() ===
                                  category.key && {
                                  color: '#D33444',
                                }),
                              }}
                              onClick={() => handleCategoryRoute(category.key)}
                            >
                              {category.title}
                            </h4>
                            {category.children.map((child) =>
                              renderChild(child),
                            )}
                          </div>
                        ))}
                        defaultOpened={false}
                      />
                    </div>
                  )}

                  {/* SECTION: 필터 영역 */}
                  <div
                    style={{
                      borderTop: isPresent
                        ? '2px solid var(--black-color)'
                        : 'none', // 선물하기일 때만 border-top 추가
                      marginTop: isPresent ? (screenSize >= 768 ? 53 : 42) : 0, // 선물하기일 때만 marginTop 추가
                    }}
                  >
                    {filterItems.map((_item, _index) => (
                      <div key={`filter_${_index}`}>
                        <FilterOption
                          title={_item.title}
                          options={_item.options}
                          multiple={_item.multiple}
                          value={
                            selectedFilter.find(
                              (filter) => filter.key === _item.key,
                            )
                              ? selectedFilter.find(
                                  (filter) => filter.key === _item.key,
                                ).value
                              : []
                          }
                          style={{
                            padding: '24px 0px',
                            borderBottom: '1px solid #DDDDDD',
                          }}
                          collapsible={true}
                          onChange={(e) =>
                            handleSelectFilter(_item.key, e, _item.type)
                          }
                        />
                      </div>
                    ))}
                  </div>
                  {/* SECTION: 검색 버튼 */}
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      //gap: '24px',
                      rowGap: 10,
                      marginTop: 24,
                    }}
                  >
                    <Button
                      type="secondary"
                      style={{ ...styles.button }}
                      onClick={() => handleSearch('reset')}
                    >
                      초기화
                    </Button>
                    <Button
                      style={{ ...styles.button }}
                      onClick={() => handleSearch('search')}
                    >
                      검색
                    </Button>
                  </div>
                </Col>
                {/* 필터 끝 */}

                {/* 상품 목록 */}
                <Col
                  x={24}
                  md={18}
                  lg={19}
                  style={{
                    paddingLeft:
                      screenSize >= 1200 ? 120 : screenSize >= 768 ? 30 : 0,
                    paddingRight: screenSize >= 768 ? 8 : 0,
                  }}
                >
                  {/* SECTION: 상품 검색 */}
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    style={{
                      paddingBottom: screenSize >= 768 ? 80 : 20,
                    }}
                  >
                    <Content
                      maxWidth={'100%'}
                      padding={0}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'space-between',
                        borderBottom: '2px solid #111111',
                        height: screenSize >= 768 ? 52 : 'auto',
                        paddingBottom: 15,
                      }}
                    >
                      <Text
                        style={{
                          webkitLineClamp: 'unset',
                          minWidth: 'fit-content',
                          fontSize:
                            screenSize >= 768
                              ? 16
                              : screenSize >= 500
                                ? 15
                                : 14,
                        }}
                      >
                        총{' '}
                        <span style={{ fontWeight: 700 }}>
                          {productItems.length}
                        </span>
                        건
                      </Text>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          //flexDirection:
                          //  screenSize >= 768 ? 'unset' : 'column-reverse',
                          gap: 15,
                          rowGap: screenSize >= 768 ? 0 : 20,
                        }}
                      >
                        <DropDownMenu
                          items={sortItems.map((item) => ({
                            label: item.label,
                            value: item.key,
                          }))}
                          value={tabKey}
                          onSelect={({ value }) => setTabKey(value)}
                          layoutStyle={{
                            paddingLeft: 10,
                          }}
                        />
                        <DropDownMenu
                          items={PAGE_NUM}
                          value={pageSize}
                          onSelect={({ value }) => setPageSize(value)}
                        />

                        <Button
                          style={{
                            width: 45,
                            borderRadius: 0,
                            backgroundColor: 'transparent',
                            color: 'var(--black-color)',
                            fontSize: 14,
                            padding: 0,
                            display: screenSize >= 768 ? 'none' : 'flex',
                            alignItems: 'center',
                            gap: 5,
                          }}
                          onClick={() => setIsOpen(true)}
                        >
                          필터
                          <img src={Filter} alt="필터" />
                        </Button>
                      </div>
                    </Content>
                  </Content>

                  {/* SECTION: 상품목록 */}
                  <Row
                    gutter={
                      screenSize >= 768
                        ? [60, 100]
                        : screenSize >= 500
                          ? [20, 30]
                          : [15, 20]
                    }
                  >
                    {productItems.length ? (
                      productItems
                        .slice(
                          (currentPage - 1) * pageSize,
                          currentPage * pageSize,
                        )
                        .map((_item, _index) => (
                          <Col
                            x={12}
                            md={12}
                            lg={8}
                            key={`product_${_item.key}_${_index}`}
                          >
                            {(_item.type !== 'AMOUNT' ||
                              type === 'present') && (
                              <ProductItem
                                key={_item.key}
                                src={_item.src}
                                title={_item.title}
                                tags={_item.tags}
                                brand={_item.brand}
                                comment={_item.comment}
                                score={_item.score}
                                prefix={_item.type === 'RENTAL' ? '월' : null}
                                isSoldOut={
                                  _item.isSoldOut === 'Y' ? true : false
                                }
                                price={_item.price}
                                discount={_item.discount}
                                discountType={_item.discount_type}
                                discountPrice={_item.finalPrice}
                                policies={_item.policies}
                                hovered={_item.type === 'RENTAL' ? false : true}
                                onClick={() =>
                                  navigate(
                                    `/products/${encodeURIComponent(
                                      encrypt(_item.key),
                                    )}`,
                                  )
                                }
                                buttons={[
                                  {
                                    render: () =>
                                      _item.isWish ? (
                                        <HeartFilled
                                          style={{
                                            color: '#D33444',
                                            fontSize: 24,
                                          }}
                                        />
                                      ) : (
                                        <img src={Heart} alt="찜하기" />
                                      ),
                                    onClick: (event) => {
                                      handleRenderModal('wishlist', _item);
                                      event.stopPropagation();
                                    },
                                  },
                                  {
                                    render: () => (
                                      <Badge
                                        count={cartList
                                          .filter(
                                            (cart) =>
                                              cart.product_id === _item.key,
                                          )
                                          .reduce(
                                            (acc, cur) => (acc += cur.cart_num),
                                            0,
                                          )}
                                      >
                                        <img src={Cart} alt="장바구니" />
                                      </Badge>
                                    ),
                                    onClick: (event) => {
                                      handleRenderModal('cart', _item);
                                      event.stopPropagation();
                                    },
                                  },
                                ]}
                                icons={[
                                  ...(_item.isBest === 'Y'
                                    ? [
                                        {
                                          label: 'BEST',
                                          color: 'rgb(202, 97, 98)',
                                        },
                                      ]
                                    : []),
                                  ...(_item.isNew === 'Y'
                                    ? [
                                        {
                                          label: 'NEW',
                                          color: 'rgb(56, 56, 56)',
                                        },
                                      ]
                                    : []),
                                ]}
                              />
                            )}
                          </Col>
                        ))
                    ) : (
                      <div
                        style={{
                          width: '100%',
                          height: 800,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Empty
                          description={
                            <Text size={18}>조건에 맞는 상품이 없습니다.</Text>
                          }
                        />
                      </div>
                    )}
                  </Row>

                  {/* SECTION: 페이지네이션 */}
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    style={{ marginTop: screenSize >= 768 ? 200 : 80 }}
                  >
                    <Pagination
                      total={productItems.length}
                      pageSize={pageSize}
                      showPage={5}
                      current={currentPage}
                      onShowSizeChange={(current, size) => {
                        setCurrentPage(1); // 페이지 크기 변경 시 페이지 초기화
                      }}
                      onChange={(page) => setCurrentPage(page)}
                      buttonStyle={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: '#999999',
                        background: 'none',
                        width: 28,
                        height: 28,
                      }}
                      isButton={true}
                      activeStyle={{
                        color: `var(--black-color) !important`,
                        borderBottom: '2px solid #111111',
                      }}
                      hoverStyle={{ color: `var(--black-color) !important` }}
                      navStyle={{ border: '1px solid var(--black-color)' }}
                      isLatestButton={true}
                    />
                  </Content>
                </Col>
                {/* 상품 목록 끝 */}
              </Row>
            </Col>
            <Col x={0} md={1} xxl={2}></Col>
          </Row>
        </Content>
      </Spin>
      {modalData?.data ? (
        <ProductCartModal
          type={modalData.type}
          data={modalData.data}
          onClose={() => setModalData({ type: '', data: null })}
          onOk={onSubmit}
        />
      ) : null}

      {/* 모바일 필터 */}
      <ModalLayout
        maxWidth={'100%'}
        type="drawer"
        open={isOpen}
        onChange={setIsOpen}
      >
        {/* 필터 */}
        <Content maxWidth={'100%'} padding={0}>
          {/* SECTION: 필터 영역 */}
          <div style={{ paddingBottom: 50 }}>
            {filterItems.map((_item, _index) => (
              <div key={`filter_${_index}`}>
                <FilterOption
                  title={_item.title}
                  options={_item.options}
                  multiple={_item.multiple}
                  value={
                    selectedFilter.find((filter) => filter.key === _item.key)
                      ? selectedFilter.find(
                          (filter) => filter.key === _item.key,
                        ).value
                      : []
                  }
                  style={{
                    padding: '24px 0px',
                    borderBottom: '1px solid #DDDDDD',
                  }}
                  collapsible={true}
                  onChange={(e) => handleSelectFilter(_item.key, e, _item.type)}
                />
              </div>
            ))}
          </div>
          {/* SECTION: 검색 버튼 */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '24px',
              marginTop: 24,
              position: 'fixed',
              bottom: 0,
              left: 0,
              width: '100%',
              padding: '20px 15px',
              backgroundColor: 'var(--white-color)',
              zIndex: 99999,
            }}
          >
            <Button
              type="secondary"
              style={{ ...styles.button }}
              onClick={() => {
                handleSearch('reset');
                setIsOpen(false);
              }}
            >
              초기화
            </Button>
            <Button
              style={{ ...styles.button }}
              onClick={() => {
                handleSearch('search');
                setIsOpen(false);
              }}
            >
              검색
            </Button>
          </div>
        </Content>
      </ModalLayout>
      {/* 모바일 필터 끝 */}
    </React.Fragment>
  );
};

export default ProductsPresenter;
